import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { Notification, WysiwygField } from '../../../components';
import { SCREEN_TABLET } from '../../../config/constants';
import {
  ParagraphEmbedDiagram as Type,
} from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

export interface ParagraphEmbedDiagramProps extends React.HTMLProps<HTMLDivElement> {
  entity: {
    toJS: () => Type;
  }
}

function setDangerousHtml(html: string, el: HTMLDivElement | null) {
  if (el === null) return;
  const range = document.createRange();
  range.selectNodeContents(el);
  range.deleteContents();
  el.appendChild(range.createContextualFragment(html));
}

const ParagraphEmbedDiagram: React.FC<ParagraphEmbedDiagramProps> = ({ entity }) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const paragraph = entity.toJS();
  const html = paragraph.field_body?.[0]?.value ?? '';
  const title = paragraph.field_title?.[0]?.value;
  const body = paragraph.field_text?.[0]?.value;

  return (
    <Container className="Paragraph ParagraphEmbedDiagram">
      <div className="row">
        <div className="col-12 col-lg-8">
          {title && <h2>{title}</h2>}
          {body && <WysiwygField html={body} />}
        </div>

        {width < SCREEN_TABLET && (
          <div className="col-12 col-lg-8">
            <Notification title={t('components.notification.title')}>
              <p>{t('general.notification_mobile_report_contains_diagrams')}</p>
            </Notification>
          </div>
        )}

        <div className="col-12 col-lg-10">
          <div
            className="ParagraphEmbedDiagram__embed"
            ref={setDangerousHtml.bind(null, html)}
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphEmbedDiagram;
